import * as React from "react";

function SvgNotStarted(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={8} cy={8.5} r={4.5} fill="#fff" stroke="#000" />
    </svg>
  );
}

export default SvgNotStarted;
